import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import styles from './PaginationComponent.module.scss';

export default function PaginationComponent({metaData, currentPage,setCurrentPage}) {

  const previousPage = () => {
    if (parseInt(currentPage) !== 1) {
      setCurrentPage(parseInt(currentPage) - 1);
    }
 };

 const nextPage = () => {
    if (parseInt(currentPage) < metaData.last_page) {
      setCurrentPage(parseInt(currentPage) + 1);
    }
 };

  const handlePageClick = (e) => {
      setCurrentPage(e.target.ariaLabel);
    }
  return (
    <Pagination aria-label="Page navigation" className={`${styles.navigation} overflow-auto`}>
        
      {
        metaData &&
        metaData.links.map((pageNumber,i) => (
          <div key={i} id={i} className={`${styles.pageItem}`}>
            {
              i === 0 
              ? (
                <PaginationItem>
                  <PaginationLink aria-label={pageNumber.label} previous onClick={previousPage}/>
                </PaginationItem>
              ) 
              : (i + 1  === metaData.links.length 
                  ? (
                    <PaginationItem>
                      <PaginationLink aria-label={pageNumber.label} next onClick={nextPage} />
                    </PaginationItem>
                  ) 
                  : (
                    <PaginationItem>
                      <PaginationLink 
                        onClick={handlePageClick}
                        aria-label={pageNumber.label}
                        key={`k${pageNumber.label}`}  
                        className={`${currentPage == pageNumber.label ? 'active' : ''} ${pageNumber.url === null && 'disabled'}`}>
                        {pageNumber.label}
                      </PaginationLink>
                    </PaginationItem>
                  )
                )
              }
          </div>
              )
        )
      }

      </Pagination>
  )
}
